export default __webpack_public_path__ + "static/media/landing_section_2.8754148e.svg";